import { SKILL_LEVEL_LABELS, type SkillLevel } from '@/components/SkillLevelBadge';
import { SPORT_LABELS } from '@/types';

export type IneligibleReason = 'skill_mismatch' | 'sport_mismatch';

export interface RankedJoinEligibility {
  eligible: boolean;
  reason?: IneligibleReason;
  shortLabel: string;
  message: string;
}

interface Params {
  isRanked: boolean;
  matchSport?: string | null;
  mySkillLevel?: string | null;
  myRankedSport?: string | null;
  creatorSkillLevel?: string | null;
}

const OK: RankedJoinEligibility = { eligible: true, shortLabel: '', message: '' };

const skillLabel = (lvl?: string | null) =>
  (lvl && SKILL_LEVEL_LABELS[lvl as SkillLevel]) || lvl || '—';

const sportLabel = (s?: string | null) =>
  (s && SPORT_LABELS[s as keyof typeof SPORT_LABELS]) || s || '—';

/**
 * Mirror of the server-side checks in `useRequestJoinMatch` for ranked matches:
 * - skill_level must match the creator's
 * - ranked_sport (if set on user) must match the match's sport
 * Used to gate the join button on cards/detail and explain the reason.
 */
export function getRankedJoinEligibility(p: Params): RankedJoinEligibility {
  if (!p.isRanked) return OK;

  if (p.mySkillLevel && p.creatorSkillLevel && p.mySkillLevel !== p.creatorSkillLevel) {
    return {
      eligible: false,
      reason: 'skill_mismatch',
      shortLabel: 'Khác trình độ',
      message: `Trận rank chỉ dành cho trình độ ${skillLabel(p.creatorSkillLevel)}. Trình độ của bạn là ${skillLabel(p.mySkillLevel)}.`,
    };
  }

  if (p.myRankedSport && p.matchSport && p.myRankedSport !== p.matchSport) {
    return {
      eligible: false,
      reason: 'sport_mismatch',
      shortLabel: 'Khác môn rank',
      message: `Môn ranked của bạn (${sportLabel(p.myRankedSport)}) không khớp với trận này (${sportLabel(p.matchSport)}).`,
    };
  }

  return OK;
}
